import React, {useCallback, useContext, useRef} from "react";
import {Image} from "react-bootstrap";
import {WizardContext} from "../Wizard";
import {SET_REFERENCE_FILE} from "../../WizardConstants";

export function WizardFormFile() {
    const {imgFiles, imgList, dispatch} = useContext(WizardContext);
    const inputRef = useRef();
    const onChange = useCallback(
        (e) => {
            const reader = new FileReader();
            const file = e.target.files[0];

            const fileExt = file?.name && file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
            if (fileExt === 'webp' || !fileExt) {
                return false;
            }

            reader.onloadend = () => {
                const copyFile = [...imgFiles, file]
                const copyImg = [...imgList, reader.result]
                dispatch({type: SET_REFERENCE_FILE, imgFiles: copyFile, imgList: copyImg})
            }

            reader.readAsDataURL(file)
        },
        [imgFiles, imgList, dispatch],
    );

    const removeImg = useCallback(
        (i) => {
            const copyFile = [...imgFiles];
            copyFile.splice(i, 1);
            const copyImg = [...imgList];
            copyImg.splice(i, 1)
            dispatch({type: SET_REFERENCE_FILE, imgFiles: copyFile, imgList: copyImg})
            // setImg(copyImg)
        },
        [imgFiles, imgList, dispatch],
    );

    return (
        <div className="form-group">
            <label style={{fontWeight: "bold"}}>참고이미지</label>
            <br/>
            {
                imgList && imgList.map((item, i) =>
                    <div key={"design-" + i} className="d-inline-block">
                        <Image alt={""} src={item} rounded width={171} height={180}/>
                        <span
                            onClick={() => removeImg(i)}
                            className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                            data-action="remove"
                            data-toggle="tooltip"
                            title=""
                            data-original-title="Remove avatar"
                        >
                          <i className="ki ki-bold-close icon-xs text-muted"></i>
                        </span>
                    </div>
                )
            }
            <div className={`form-control form-control-solid form-control-lg p-0 ${imgList.length >= 2 && 'd-none'}`}
                 style={{backgroundColor:"#6993ff",display:"flex"}} >
                <i className="fa fa-image" aria-hidden="true" style={{marginTop:'14px',marginLeft:'21px', color:'#fff'}}></i>
                <label htmlFor="wizardFormImg" className="w-100 h-100" 
                       style={{marginTop:'12px', marginLeft:'10px',color:'#fff'}}>파일업로드</label>
                <input type="file" className="d-none"
                       name="img" placeholder="img" id="wizardFormImg" onChange={onChange} ref={inputRef}/>
            </div>

            {/*<span className="form-text text-muted">Please enter your Address.</span>*/}
        </div>

    )
}